import script from "./esTaskBoxForm.vue?vue&type=script&setup=true&lang=ts"
export * from "./esTaskBoxForm.vue?vue&type=script&setup=true&lang=ts"

import "./esTaskBoxForm.vue?vue&type=style&index=0&id=110b58b0&scoped=true&lang=css"

import exportComponent from "/home/aschmuck/wk/eSklepios/medsw/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-110b58b0"]])

export default __exports__